module.exports = __webpack_public_path__ + "img/casimir-crystal.cb17dbb8.png";